<ngx-form-list
  title="Business Units"
  [columns]="businessUnitsColumns"
  [(value)]="businessUnits"
  (valueChange)="change($event)"
  (editConfirm)="validate($event)"
>
</ngx-form-list>
